import { FC } from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import CompanyAvatar from '../CompanyAvatar'
import CompanyInfo from '../CompanyInfo'
import AddCompanyButton from './AddCompanyButton'
import { getSelectedCompanyId } from 'store/me'
import { menuItemStyles } from '../../_styles'
import { useTranslation } from 'react-i18next'
import { NavigationLeftIcon, CheckIcon } from 'components/Common/Icons'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  background: var(--grey-100, #121432);
  z-index: var(--z-index-tooltip);
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

const ListItem = styled.div`
  display: flex;
  padding: 12px;
  flex-direction: row;
  align-items: flex-start;
  align-self: stretch;
  gap: 8px;

  ${menuItemStyles()};
`

const List = styled.div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  gap: 2px;
  flex: 1;
  padding: 16px;
  max-width: 100%;
  overflow: hidden auto;
`

const Header = styled.div`
  display: grid;
  grid-template-columns: 48px 1fr 48px;
  gap: 24px;
  align-items: center;
  height: 48px;
  width: 100%;
  color: var(--grey-10, #e7e7ea);
  text-align: center;
  font: var(--typography-16-24-semibold);
  border-bottom: 1px solid var(--grey-80, #41435b);
  background: var(--grey-100, #121432);
`

const BackButton = styled.button`
  all: unset;
  display: flex;
  padding: 12px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 48px;
`

interface CompaniesListProps {
  items: any[]
  onSelectCompany: (company: any) => void
  onClose: () => void
}

const CompaniesList: FC<CompaniesListProps> = props => {
  const { items, onSelectCompany, onClose } = props

  const { t } = useTranslation()

  const selectedId = useSelector(getSelectedCompanyId)

  return (
    <Wrapper>
      <Header>
        <BackButton type='button' onClick={onClose}>
          <BackIcon />
        </BackButton>
        {t('common.menu.user.companiesList')}
      </Header>

      <List>
        {items.map(item => (
          <ListItem key={item.id} onClick={() => onSelectCompany(item)}>
            <CompanyAvatar
              avatar={item?.avatar}
              status={item?.verificationStatus?.code}
            />
            <CompanyInfo data={item} />
            {selectedId === item.id && <IconSelected />}
          </ListItem>
        ))}

        <AddCompanyButton onClose={onClose} />
      </List>
    </Wrapper>
  )
}

const IconSelected = CheckIcon

const BackIcon = NavigationLeftIcon

export default CompaniesList
